<template>
  <Clearpay v-if="price" :price="price" />
</template>

<script>
import Clearpay from "@/components/product-display/bnpl-providers/Clearpay.vue";

export default {
  name: "BNPLInformation",
  components: {
    Clearpay,
  },
  props: {
    price: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
